// src/components/ProtectedRoute.jsx
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { selectAuth, selectIsInitialized } from '../store/slices/authSlice';
import CustomLoader from '../dashboard/components/CustomLoader';

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAppSelector(selectAuth);
  const isInitialized = useAppSelector(selectIsInitialized);

  if (!isInitialized || isLoading) {
    return <CustomLoader message="Authenticating..." />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;